import * as React from "react";

import { PropertyWhatsAroundPoisView as SharedUiPropertyWhatsAroundPoisView } from "@shared-ui/lodging-property-details";

import { ComponentProps } from "src/typings/flexFramework/FlexComponent";
import { PropertyBexApiWrapper } from "src/components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { UitkSpacing } from "uitk-react-spacing";

const WrappedSharedUiPropertyWhatsAroundPoisView = PropertyBexApiWrapper(SharedUiPropertyWhatsAroundPoisView);

export const PropertyWhatsAroundPoisView = (props: ComponentProps) => {
  const { context } = props;

  return (
    <UitkSpacing margin={{ block: "three" }}>
      <section>
        <WrappedSharedUiPropertyWhatsAroundPoisView context={context} />
      </section>
    </UitkSpacing>
  );
};

export default PropertyWhatsAroundPoisView;
